module.exports = __webpack_public_path__ + "static/media/Desu Japanese.227a3f68.jpg";